import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '17px',
    width: '100%'
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid rgba(230, 234, 236, 0.9)',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '292px',
    padding: '9px 0',
    backgroundColor: '#F7F8F9',
    color: '#323436'
  },

  darkBorder: {
    borderColor: 'rgba(206, 206, 206, 0.9)'
  },

  help: {
    marginBottom: '10px'
  },

  reason: {
    fontSize: theme.size.lg
  }
}))

export default useStyles
